import Component from '../Component';
import $ from '../../vendor/CustomJquery';
import MapboxMap from "./MapboxMap";

export default class Manager extends Component {

  _instances = {};

  configure() {
    return super.configure();
  }

  initialize() {
    return super.initialize();
  }

  create(id, options) {
    this._instances[id] = new MapboxMap(
      this.App,
      this.namespace,
      id,
      options
    );
    return this._instances[id];
  }

  get(id) {
    if (typeof this._instances[id] === 'undefined') {
      throw new Error(`Map[${id}] does not exist`);
    }
    return this._instances[id];
  }

}